<template>
	<div class='authentication'>
		<div class="renz_box">
			<div class="renz_item">
				<div class="top">
					<div class="title">实名认证</div>
					<div class="right">
						<div
							class="status"
							v-if="sfRz !== 0"
							@click="realVisible = true;isView= true"
						>
							<img
								style="width: 16px;"
								:src="$store.state.wqurl + 'certificationPage_renz1.png'"
							>
							{{ sfRz == 1 ? '实名认证已完成' : ''}}
							<div style="color: #999;">
								<i class="el-icon-arrow-right"></i>
							</div>
						</div>
						<div
							v-else
							class="renz_btn"
							@click="realVisible = true;isView= false"
						>
							去认证
						</div>
					</div>
				</div>
				<div class="describe">
					适用于用户在发布特定类型任务、专服人员申请执业类型场景，如发布律师相关任务。
				</div>
			</div>
			<div class="renz_item">
				<div class="top">
					<div class="title">企业认证</div>
					<div class="right">
						<div
							class="status"
							@click="oneVisible = true;isView= true"
							v-if="qyRz !== 0 && qyRz !== 3"
						>
							<img :src="$store.state.wqurl + 'certificationPage_renz.png'">
							{{qyRz == 1 ? '企业认证审核中' : qyRz == 2 ? '企业认证已完成' : qyRz == 3 ? '企业认证未通过' : ''}}
							<div style="color: #999;">
								<i class="el-icon-arrow-right"></i>
							</div>
						</div>
						<div
							v-else
							class="renz_btn"
							@click="oneVisible = true;isView= false"
						>
							{{ qyRz == 0 ? '去认证' : '重新认证' }}
						</div>
					</div>
				</div>
				<div class="describe">
					适用于以企业身份发布任务的用户
				</div>
			</div>
		</div>

		<!-- 实名认证弹框 -->
		<el-dialog
			title="实名认证"
			:visible.sync="realVisible"
			width="30%"
		>
			<div>
				<el-form
					label-width="80px"
					:model="form"
				>
					<el-form-item label="真实姓名">
						<el-input
							:disabled="isView"
							placeholder="请输入真实姓名"
							v-model="form.realname"
						></el-input>
					</el-form-item>
					<el-form-item label="身份证号">
						<el-input
							:disabled="isView"
							placeholder="请输入身份证号"
							v-model="form.reccode"
						></el-input>
					</el-form-item>
				</el-form>
				<div class="img_box">
					<div class="title">上传身份证照片</div>
					<div
						class="upload_box"
						:style="{ alignItems: front_img ? 'center' : '',cursor: 'pointer' }"
						@click="uploadImg(0)"
					>
						<div
							class="del_img"
							v-if="front_img"
							@click.stop="deleteIDCard(true)"
						>
							<i class="el-icon-circle-close"></i>
						</div>
						<img
							v-if="front_img"
							style="margin-top: 0; width: 80%; height: 80%;"
							:src="front_img"
							mode="aspectFill"
						/>
						<img
							v-else
							:src="imgUrl + 'realNameVerification_card_front.png'"
							mode="aspectFill"
						/>
						<div
							v-if="!front_img"
							class="btn"
						>上传/拍摄正面</div>
					</div>
					<div
						class="upload_box"
						:style="{ alignItems: back_img ? 'center' : '',cursor: 'pointer' }"
						@click="uploadImg(1)"
					>
						<div
							class="del_img"
							v-if="back_img"
							@click.stop="deleteIDCard(false)"
						>
							<i class="el-icon-circle-close"></i>
						</div>
						<img
							v-if="back_img"
							style="margin-top: 0; width: 80%; height: 80%"
							:src="back_img"
							mode="aspectFill"
						/>
						<img
							v-else
							:src="imgUrl + 'realNameVerification_card_back.png'"
							mode="aspectFill"
						/>
						<div
							v-if="!back_img"
							class="btn"
						>上传/拍摄背面</div>
					</div>
				</div>
			</div>
			<span
				slot="footer"
				class="dialog-footer"
				v-if="!isView"
			>
				<el-button @click="
            realVisible = false
            front_img = ''
            back_img = ''
            form.realname = ''
            form.reccode = ''
          ">取 消</el-button>
				<el-button
					type="primary"
					@click="realfime"
				>确 定</el-button>
			</span>
		</el-dialog>

		<!-- 企业认证 -->
		<el-dialog
			title="企业认证"
			top="5vh"
			:visible.sync="oneVisible"
			width="30%"
		>
			<div>
				<div class="content_box">
					<div class="img_box">
						<div class="title">上传营业执照</div>
						<div
							class="upload_box"
							:style="{
                alignItems: enterpriseObj.businessLicense ? 'center' : '',
              }"
							@click="$refs.filesi.click()"
						>
							<img
								v-if="enterpriseObj.businessLicense"
								style="margin-top: 0; width: 80%; height: 80%"
								:src="enterpriseObj.businessLicense"
								mode="aspectFill"
							/>
							<img
								v-else
								:src="$store.state.wqurl + 'certificationPage_renz2.png'"
								mode="aspectFill"
							/>
							<div
								v-if="!enterpriseObj.businessLicense"
								class="btn"
							>
								上传/拍摄正面
							</div>
						</div>
					</div>
					<div
						class="input_box"
						style="margin-top: 35px"
					>
						<span style="font-weight: 600"><span style="color: red; margin-right: 5px">*</span>名称</span>
						<input
							:disabled="isView"
							type="span"
							v-model="enterpriseObj.enterpriseName"
							placeholder="请输入名称"
							:maxlength="30"
						/>
					</div>
					<div class="input_box">
						<span style="font-weight: 600"><span style="color: red; margin-right: 5px">*</span>类型</span>
						<input
							:disabled="isView"
							type="span"
							v-model="enterpriseObj.enterpriseType"
							placeholder="请输入类型"
							:maxlength="30"
						/>
					</div>
					<div class="input_box">
						<span style="font-weight: 600"><span style="color: red; margin-right: 5px">*</span>住所</span>
						<input
							:disabled="isView"
							type="span"
							v-model="enterpriseObj.enterpriseAddress"
							placeholder="请输入住所"
							:maxlength="30"
						/>
					</div>
					<div class="input_box">
						<span style="font-weight: 600"><span style="color: red; margin-right: 5px">*</span>法定代表人</span>
						<input
							:disabled="isView"
							type="span"
							v-model="enterpriseObj.enterpriseLegalPerson"
							placeholder="请输入法定代表人"
							:maxlength="10"
						/>
					</div>
					<div class="input_box">
						<span style="font-weight: 600"><span style="color: red; margin-right: 5px">*</span>营业期限</span>
						<input
							:disabled="isView"
							type="span"
							v-model="enterpriseObj.enterpriseValidityPeriod"
							placeholder="请输入营业期限"
							:maxlength="30"
						/>
					</div>
					<div class="input_box">
						<span style="font-weight: 600"><span style="color: red; margin-right: 5px">*</span>证照编号</span>
						<input
							:disabled="isView"
							type="span"
							v-model="enterpriseObj.enterpriseIdNumber"
							placeholder="请输入证照编号"
							:maxlength="30"
						/>
					</div>
					<div class="input_box">
						<span style="font-weight: 600"><span style="color: red; margin-right: 5px">*</span>社会信用代码</span>
						<input
							:disabled="isView"
							type="span"
							v-model="enterpriseObj.enterpriseSocialCreditCode"
							placeholder="请输入社会信用代码"
							:maxlength="18"
						/>
					</div>
				</div>
			</div>
			<span
				slot="footer"
				class="dialog-footer"
				v-if="!isView"
			>
				<el-button @click="oneVisible = false">取 消</el-button>
				<el-button
					type="primary"
					@click="Certification()"
				>提交</el-button>
			</span>
		</el-dialog>

		<!-- 上传身份证正反面 -->
		<input
			type="file"
			style="display: none"
			@change="reccodeUpload"
			ref="file"
		/>

		<!-- 上传营业执照 -->
		<input
			type="file"
			accept="image/*"
			style="display: none"
			@change="uploadgonsi"
			ref="filesi"
		/>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  getUserAuthenticationInfo,
  ossUpload,
  deleteIDCard,
  identifyCardInfo,
  identifyBusinessLicense,
  addRealname,
  enterpriseCertification,
} from "@/api/professionServer";
import qs from "qs";
export default {
  name: "authentication",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      imgUrl: this.$store.state.wqurl,
      enterprise: {}, //企业认证信息
      person: {}, // 实名认证信息
      qyRz: -1,
      sfRz: -1,
      // 实名认证弹框
      realVisible: false,
      // 实名认证
      form: {
        realname: "",
        reccode: "",
      },
      frontType: 0,
      front_img: "",
      back_img: "",
      isView: false,
      // 企业认证弹框
      oneVisible: false,
      enterpriseObj: {
        businessLicense: "", //执照链接
        enterpriseName: "", //单位名称
        enterpriseType: "", //类型
        enterpriseAddress: "", //地址
        enterpriseLegalPerson: "", //法人
        enterpriseValidityPeriod: "", //有效期
        enterpriseIdNumber: "", //证件号
        enterpriseSocialCreditCode: "", //信用代码
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    async getUserAuthenticationInfo() {
      const res = await getUserAuthenticationInfo();
      if (res.code !== 200) return;
      this.qyRz = res.data.enterpriseAuthenticationStatus;
      this.sfRz = res.data.authenticationStatus;
      this.enterprise = res.data;
      this.enterpriseObj = res.data;
      this.form.realname = res.data.cardName;
      this.form.reccode = res.data.idNumber;
      this.front_img = res.data.frontImg;
      this.back_img = res.data.reverseImg;
    },

    uploadImg(i) {
      this.frontType = i;
      this.$refs.file.click();
    },

    // 上传身份证
    async reccodeUpload(e) {
      let file = e.target.files[0];
      let form = new FormData();
      form.append("file", file);
      form.append("file_name", file.name);
      const res = await ossUpload(form);
      console.log(res);
      if (res.code == 200) {
        if (this.frontType == 0) {
          this.front_img = res.data;
        } else {
          this.back_img = res.data;
        }
        if (this.front_img && this.back_img) {
          this.identifyCardInfo();
        }
      }
    },

    // 上传
    async uploadgonsi(e) {
      let file = e.target.files[0];
      let form = new FormData();
      form.append("file", file);
      form.append("file_name", file.name);
      const res = await ossUpload(form);
      if (res.code == 200) {
        let data = {
          httpImg: res.data,
        };

        let res1 = await identifyBusinessLicense(qs.stringify(data));

        if (res1.code !== 200) return;
        this.enterpriseObj = res1.data;
        this.enterpriseObj.businessLicense = res.data;
      }
    },

    // 删除身份证
    async deleteIDCard(type) {
      let res = await deleteIDCard(type);
      if (res.code !== 200) return;
      if (type) {
        this.front_img = "";
      } else {
        this.back_img = "";
      }
    },

    // 识别身份证
    async identifyCardInfo() {
      let data = {
        frontImg: this.front_img,
        reverseImg: this.back_img,
      };
      this.$message.success("开始识别");
      let res = await identifyCardInfo(data);
      if (res.code !== 200) {
        this.$message.error(res.data);
        return;
      }
      this.form.realname = res.data.name;
      this.form.reccode = res.data.number;
    },

    // 确定实名
    async realfime() {
      if (!this.form.realname || !this.form.reccode) {
        this.$message.error("请将信息填写完成");
        return;
      }
      let opt = {
        cardName: this.form.realname,
        realnameType: 1,
        idNumber: this.form.reccode,
      };
      let res = await addRealname(opt);
      if (res.code !== 200) {
        this.$message.error(res.message);

        return;
      }
      this.$message.success("提交成功");
      this.getUserAuthenticationInfo();
      this.realVisible = false;
    },

    // 企业认证提交
    async Certification() {
      if (!this.enterpriseObj.businessLicense) {
        this.$message.error("请上传营业执照");

        return;
      }
      if (this.isPractice || this.isEdit) {
        if (
          !this.enterpriseObj.enterpriseName ||
          !this.enterpriseObj.enterpriseType ||
          !this.enterpriseObj.enterpriseAddress ||
          !this.enterpriseObj.enterpriseLegalPerson ||
          !this.enterpriseObj.enterpriseValidityPeriod ||
          !this.enterpriseObj.enterpriseIdNumber ||
          !this.enterpriseObj.enterpriseSocialCreditCode
        ) {
          this.$message.error("请将信息填写完整");

          return;
        }
        //  this.$store.commit("",this.enterpriseObj).enterpriseCertification =
        this.$message.success("提交成功");

        // this.back()
        return;
      }
      let res = await enterpriseCertification(qs.stringify(this.enterpriseObj));
      if (res.code == 415) {
        this.$message.error(res.data);

        return;
      }
      if (res.code !== 200) {
        this.$message.error(res.message);
        return;
      }
      this.$message.success("提交成功");
      this.getUserAuthenticationInfo();
      this.oneVisible = false;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getUserAuthenticationInfo();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
.authentication {
  .renz_box {
    width: 100%;
    background: #fff;
    border-radius: 10px;
    padding: 15px;
    box-sizing: border-box;
    margin-top: 20px;
    .renz_item {
      padding: 15px 0;
      border-bottom: 1px solid #ebebeb;
    }
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title {
        font-size: 16px;
        font-weight: bold;
      }
      .right {
        display: flex;
        align-items: center;
        .status {
          cursor: pointer;
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #999;
          gap: 5px;
          margin-right: 10px;
          > img {
            width: 17px;
            vertical-align: middle;
          }
        }
        .renz_btn {
          height: 25px;
          cursor: pointer;
          line-height: 25px;
          padding: 0 10px;
          border-radius: 5px;
          font-size: 15px;
          color: #df534e;
          border: 1px solid #df534e;
          background: #fff;
        }
      }
    }
    .describe {
      padding: 10px 0;
      line-height: 20px;
      font-size: 13px;
      color: #666;
    }
  }

  .img_box {
    margin-top: 40px;
    position: static;

    &::after {
      right: 5px;
    }

    .title {
      font-size: 15px;
      color: #333;
      font-weight: 600;
      margin-bottom: 17px;
    }

    .upload_box {
      position: relative;
      width: 100%;
      height: 179px;
      background: #e7efff;
      border-radius: 6px;
      margin-bottom: 15px;
      display: flex;
      justify-content: center;
      .del_img {
        position: absolute;
        top: 15px;
        right: 20px;
      }
      img {
        width: 176px;
        height: 106px;
        margin-top: 20px;
      }

      .btn {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #326afb;
        font-size: 15px;
        color: #fff;
        border-radius: 0 0 6px 6px;
      }
    }
  }

  .content_box {
    width: 85%;
    min-height: 150px;
    border-radius: 10px;
    margin: 0 auto;
    background-color: #fff;
    .img_box {
      position: static;

      .title {
        font-size: 15px;
        color: #333;
        font-weight: 600;
        margin-bottom: 17px;
      }

      .upload_box {
        position: relative;
        cursor: pointer;
        width: 100%;
        height: 179px;
        background: #e7efff;
        border-radius: 6px;
        margin-bottom: 15px;
        display: flex;
        justify-content: center;

        img {
          width: 176px;
          height: 106px;
          margin-top: 20px;
        }
        .btn {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 30px;
          line-height: 30px;
          span-align: center;
          background: #326afb;
          font-size: 15x;
          color: #fff;
          border-radius: 0 0 6px 6px;
        }
      }
    }

    .input_box {
      height: 50px;
      background: #f7f8fa;
      border-radius: 10px;
      display: flex;
      align-items: center;
      padding: 0 10px;
      box-sizing: border-box;
      margin: 0 auto 10px;
      font-size: 15px;

      > span {
        margin-right: 15px;
      }
      > input {
        flex: 1;
      }
    }
  }
}
</style>